import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*global $*/

import React from "react";
import { assert } from "@/common/assert";
import { formatImageUrl } from "@/common/utils";
import "./ChatTopicPostMessageItem.scss";
import { UrlHelperExtensions } from "@/url_helpers";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export default function ChatProductMessageItem(props) {
  var attr = props.message.customAttrs;
  assert(attr, "Oops, attr is falsy");
  var title = $.trim(attr.PRODUCT_TITLE_KEY);
  var contentSpan = $("<span></span>");
  contentSpan.html(attr.PRODUCT_CONTENT_KEY);
  var content = $.trim(contentSpan.text()).slice(0, 20) + "...";
  var imgUrl = attr.PRODUCT_IMAGE_URL_KEY;
  var productId = Number(attr.PRODUCT_ID_KEY);
  var productUrl = UrlHelperExtensions.$ProductDetail(productId, {
    stat_ctx: "ChatRoom"
  });
  var previewImage = null;

  if (imgUrl && imgUrl.length > 0) {
    imgUrl = formatImageUrl(imgUrl, ImageSizeTypeEnum.Thumbnail100whFill);
    previewImage = _jsx("div", __assign({
      className: "postMsg-wrapper__img"
    }, {
      children: _jsx("img", {
        src: imgUrl
      }, void 0)
    }), void 0);
  }

  return _jsx(React.Fragment, {
    children: _jsx("div", __assign({
      className: "postMsg-wrapper"
    }, {
      children: _jsxs("div", __assign({
        className: "postMsg-wrapper__inner"
      }, {
        children: [_jsxs("div", __assign({
          className: "postMsg-wrapper__header"
        }, {
          children: [_jsx("a", __assign({
            href: productUrl,
            target: "_blank",
            className: "postMsg-wrapper__header--title",
            title: title
          }, {
            children: title
          }), void 0), _jsx("a", __assign({
            href: UrlHelperExtensions.$ProductListUrl,
            target: "_blank",
            className: "postMsg-wrapper__header--type"
          }, {
            children: "\u4EA7\u54C1\u4F9B\u5E94"
          }), void 0)]
        }), void 0), previewImage, _jsx("p", __assign({
          className: "postMsg-wrapper__content"
        }, {
          children: content
        }), void 0), _jsx("a", __assign({
          href: productUrl,
          target: "_blank",
          className: "postMsg-wrapper__button"
        }, {
          children: "\u53BB\u770B\u770B"
        }), void 0)]
      }), void 0)
    }), void 0)
  }, void 0);
}